import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '../../app-config';
import { tap } from 'rxjs/operators';
import { TokenStorageService } from '../auth/token-storage.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  observe: 'response' as 'body'
};

@Injectable({
  providedIn: 'root'
})
export class AnalisisDeBrechasService {

  AUTH_API = "";

  constructor(private http: HttpClient,
              private tokenStorage: TokenStorageService,
              private appConfig:AppConfig
              ) {
                this.AUTH_API = appConfig.api_url;
              }

  count(filtros): Observable<any> {
    return this.http.post(this.AUTH_API + 'analisis-de-brechas/count',filtros.value, httpOptions).pipe(tap(evaluacion => {
      return evaluacion;
    }));
  }

  getAll(filtros): Observable<any> {
    return this.http.post(this.AUTH_API + 'analisis-de-brechas/all',filtros.value, httpOptions).pipe(tap(evaluacion => {
      return evaluacion;
    }));
  }

  getAllByUser(filtros): Observable<any> {
    return this.http.post(this.AUTH_API + 'analisis-de-brechas/by-user',filtros.value, httpOptions).pipe(tap(analisis => {
      return analisis;
    }));
  }

  get(id): Observable<any> {
    return this.http.get(this.AUTH_API + 'analisis-de-brechas/' + id, httpOptions);
  }

  register(analisis): Observable<any> {
    return this.http.post(this.AUTH_API + 'analisis-de-brechas/add', analisis, httpOptions);
  }

  delete(id): Observable<any> {
    return this.http.delete(this.AUTH_API + 'analisis-de-brechas/' + id, httpOptions);
  }

  edit(id, analisis): Observable<any> {
    return this.http.put(this.AUTH_API + 'analisis-de-brechas/' + id, analisis, httpOptions);
  }

  addRespuesta(id, respuesta): Observable<any> {
    return this.http.put(this.AUTH_API + 'analisis-de-brechas/respuesta/' + id, respuesta, httpOptions);
  }

  addRespuestaObjetivo(id, respuesta): Observable<any> {
    return this.http.put(this.AUTH_API + 'analisis-de-brechas/respuesta/objetivo/' + id, respuesta, httpOptions);
  }

  editStatus(id, status): Observable<any> {
    return this.http.put(this.AUTH_API + 'analisis-de-brechas/'+ id+'/status', status, httpOptions);
  }

  editStatusRechazo(id, status,motivo): Observable<any> {
    return this.http.put(this.AUTH_API + 'analisis-de-brechas/'+ id+'/rechazo', motivo, httpOptions);
  }

  editTablaDeEvaluacion(id, tipo): Observable<any> {
    return this.http.put(this.AUTH_API + 'analisis-de-brechas/'+ id+'/tabla-de-evaluacion', tipo, httpOptions);
  }

  editEstructura(id, estructura): Observable<any> {
    return this.http.put(this.AUTH_API + 'analisis-de-brechas/'+ id+'/estructura', estructura, httpOptions);
  }

  editResponsable(id, owner): Observable<any> {
    return this.http.put(this.AUTH_API + 'analisis-de-brechas/'+ id+'/responsable', owner, httpOptions);
  }

  editMarcoDeReferencia(id, escenario): Observable<any> {
    return this.http.put(this.AUTH_API + 'analisis-de-brechas/'+ id+'/marco-de-referencia', escenario, httpOptions);
  }

  editFechaFin(id, fechaF): Observable<any> {
    return this.http.put(this.AUTH_API + 'analisis-de-brechas/'+ id+'/fecha-fin', fechaF, httpOptions);
  }

  editNombre(id, nombre): Observable<any> {
    return this.http.put(this.AUTH_API + 'analisis-de-brechas/'+ id+'/nombre', nombre, httpOptions);
  }

  copiar(id, nombre): Observable<any> {

    var httpOptionsLocal = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
      //observe: 'response' as 'body'
    };

    return this.http.post(this.AUTH_API + 'analisis-de-brechas/'+ id+'/copiar', {}, {...httpOptionsLocal, params:
      {nombre: nombre}
    });
  }

}
